import type * as React from 'react'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup, {
  toggleButtonGroupClasses
} from '@mui/material/ToggleButtonGroup'

const bgColor = 'rgba(113, 54, 188, 1)'
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '&.MuiToggleButtonGroup-root': {
    backgroundColor: bgColor,
    padding: '0px 10px 0px 10px',
    gap: '10px'
  },
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0
    }
  },
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    color: 'white',
    backgroundColor: bgColor,
    '&:hover': {
      color: 'white',
      backgroundColor: '#e4d1fd'
    },
    '&.disabled': {
      backgroundColor: '#cccccc',
      color: '#666666',
      border: '1px solid #999999',
      cursor: 'not-allowed'
    },
    '&.Mui-selected': {
      backgroundColor: 'white',
      color: bgColor,
      '&:hover': {
        color: 'white',
        backgroundColor: '#e4d1fd'
      }

    }
  }
}))
export interface buttonOption {
  id: number
  name: string
  disabled?: boolean
}

export default function ButtonGroup (props: { value: number, options: buttonOption[], setValue: (newVal: number) => void }): JSX.Element {
  const handleChange = (
    event: any,
    newVal: number
  ): void => {
    props.setValue(newVal)
  }

  return (
    <div>
      <Paper
        elevation={0}
        sx={() => ({
          display: 'flex',
          flexWrap: 'wrap'
        })}
      >
        <StyledToggleButtonGroup
          size="small"
          value={props.value}
          exclusive
          onChange={handleChange}
          aria-label="text alignment"
        >
          {props.options.map(o => {
            return <ToggleButton value={o.id} className={o.disabled === true ? 'disabled' : ''} data-testid={`groupButton${o.id}`} >
              {o.name}
            </ToggleButton>
          })}
        </StyledToggleButtonGroup>
      </Paper>
    </div>
  )
}
